export function generateRandomColor(): string {
    const hue = Math.floor(Math.random() * 360); // random hue value between 0 and 360
    const saturation = 75; // constant saturation value
    const lightness = 60; // constant lightness value
    const rgb = hslToRgb(hue, saturation, lightness); // convert HSL to RGB values
    const color = rgbToHex(rgb.r, rgb.g, rgb.b); // convert RGB to hex color code
    return color;
}

function hslToRgb(h: number, s: number, l: number): { r: number, g: number, b: number } {
    // convert HSL color to RGB color
    // algorithm adapted from https://css-tricks.com/converting-color-spaces-in-javascript/
    h /= 360;
    s /= 100;
    l /= 100;
    let r, g, b;
    if (s === 0) {
        r = g = b = l;
    } else {
        const hueToRgb = (p: number, q: number, t: number) => {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        };
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        r = hueToRgb(p, q, h + 1 / 3);
        g = hueToRgb(p, q, h);
        b = hueToRgb(p, q, h - 1 / 3);
    }
    return { r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255) };
}

function rgbToHex(r: number, g: number, b: number): string {
    // convert RGB color to hex color code
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}